<template>
  <div v-if="dataRaw[0] !== NaN" class="chart-container">
    <div v-if="isBigChart" :key="componentKey">
      <DonutChart :width="'300'" :height="'220'" :data="dataChart" :options="options"
                  :maintain-aspect-ratio="true"
      />
    </div>
    <div v-else :key="componentKey">
      <DonutChart :width="'240'" :height="'220'" :data="dataChart" :options="options"
                  :maintain-aspect-ratio="true"
      />
    </div>
    <div class="label-number">
      <span class="number">{{ total }}</span>
      <span class="label">Communities</span>
    </div>
  </div>
</template>

<script>
import DonutChart from './donutChart.js'
import { useWindowSize } from '@vueuse/core'

const { width } = useWindowSize()

export default {
  name: 'Donut',
  components: { DonutChart },
  props: {
    dataRaw: {
      type: Array,
      required: true
    }
  },
  computed: {
    dataChart() {
      return {
        labels: ['Public', 'Public-Broadcast', 'Private', 'Private-Broadcast'],
        datasets: [{
          label: 'Communities',
          data: this.dataRaw,
          backgroundColor: ['#F0B844', '#E69037', '#A20056', '#6E1C3B'],
          borderWidth: 0
        }],
        responsive: true
      }
    },
    options() {
      return {
        cutoutPercentage: 50,
        circumference: Math.PI,
        rotation: Math.PI,
        legend: {
          padding: 0,
          position: 'top'
        }
      }
    },
    total() {
      return Object.values(this.dataRaw).reduce((a, b) => a + b, 0)
    },
    isBigChart() {
      return width.value > 1370
    }
  },
  data() {
    return {
      componentKey: 0
    }
  },
  methods: {
    forceRender() {
      this.componentKey += 1
    }
  },
  watch: {
    isBigChart() {
      this.forceRender()
    }
  }
}
</script>

<style scoped lang="scss">

.chart-container {
  display: flex;
  justify-content: center;

  position: relative;

  .label-number {
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    font-size: 18px;
    font-weight: 600;
    @media (max-width: $medium) {
      font-size: 16px;
    }

    .number {
      font-size: 40px;
      @media (max-width: $medium) {
        font-size: 25px;
      }
    }

  }
}
</style>
